import { FC } from 'react';
import { Button, useDisclosure } from '@chakra-ui/react';
import { FaUserPlus } from 'react-icons/fa';

import {
  GetUserManagementDataQuery,
  TreatyDetailsFragment,
} from '../../graphql/generated';
import { AddUserModal } from './add-user-modal';

type AddUserButtonProps = {
  roles?: GetUserManagementDataQuery['roles'];
  treaties?: TreatyDetailsFragment[];
  startTimedPolling: () => void;
};

export const AddUserButton: FC<AddUserButtonProps> = ({
  roles,
  treaties,
  startTimedPolling,
}) => {
  const {
    isOpen: isModalOpen,
    onOpen: openModal,
    onClose: closeModal,
  } = useDisclosure();

  return (
    <>
      <Button
        onClick={openModal}
        disabled={!treaties || !roles}
        colorScheme="blue"
        variant="outline"
        leftIcon={<FaUserPlus />}
        data-testid="add-user-button"
      >
        Add External User
      </Button>

      <AddUserModal
        isOpen={isModalOpen}
        closeModal={closeModal}
        roles={roles}
        treaties={treaties}
        startTimedPolling={startTimedPolling}
      />
    </>
  );
};
